import React from "react";

import Discovery from "apps/discovery/";

const App = () => {
	return (
		<div>
			<Discovery />
		</div>
	);
};

export default App;



// WEBPACK FOOTER //
// ./src/pages/discovery/App.jsx